export default __webpack_public_path__ + "static/media/CentricSoftware.c071fd93.svg";